export default "bedicooper"